export default function useGoogleConversion() {
  return {
    sendCompleteRegistrationEvent,
    sendLeadEvent,
  };
}

function sendCompleteRegistrationEvent(
  sessionId: string,
  campaign: {
    id: number | null;
    lead_type_id: number | null;
    offer_id: number | string;
    lead_type_name: string | null;
    lead_score_baseline: number | null;
  },
  answers: Record<string, unknown>
) {
  sendGoogleAnalyticsConversion({
    event: 'CompleteRegistration',
    valid: true,
    session_id: sessionId,
    cid: `${campaign.id}`,
    ltid: `${campaign.lead_type_id}`,
    status: '1',
    oid: `${campaign.offer_id}`,
    event_id: sessionId,
    version: '2',
    lead_value: campaign.lead_score_baseline,
    form_response: answers,
  });
}

function sendLeadEvent(
  sessionId: string,
  campaign: {
    id: number | null;
    lead_type_id: number | null;
    offer_id: number | string;
    lead_type_name: string | null;
    lead_score_baseline: number | null;
  },
  answers: Record<string, unknown>,
  contact: {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    zip_code: string;
  }
) {
  sendGoogleAnalyticsConversion({
    event: 'Lead',
    valid: true,
    session_id: sessionId,
    cid: `${campaign.id}`,
    ltid: `${campaign.lead_type_id}`,
    status: 1,
    oid: `${campaign.offer_id}`,
    userEmail: contact.email,
    userPhone: contact.phone,
    event_id: sessionId,
    version: '2',
    lead_value: campaign.lead_score_baseline,
    form_response: answers,
  });
}

function sendGoogleAnalyticsConversion(properties: unknown) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(properties);
  } catch (err) {
    console.error('Unable to send event to GA:  ', err);
  }
}

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}
